import apiClient from './client'

export interface DeviceTypeOption {
  id: number
  value: string
  label: string
  icon?: string
  color?: string
}

export const getDeviceTypesList = async (): Promise<DeviceTypeOption[]> => {
  const response = await apiClient.get('/api/deviceTypesList')
  
  // Check if response.data is the array we need (from interceptor)
  if (Array.isArray(response.data)) {
    return response.data
  }
  
  // Fallback for raw response format
  if (response && response.data && response.data.success) {
    return response.data.data
  }
  
  throw new Error('Failed to fetch device types list')
}
